import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentLoop: null,
    loopThemes: [],
    loopKPIs: [],
    loopGoals: [],
    loopLayers: [],
    loopSegments: [],
    loading: false,
    error: null,
    length: null
};

const loopSlice = createSlice({
    name: "loop",
    initialState,
    reducers: {
        setCurrentLoop(state, action) {
            state.currentLoop = action.payload;
        },
        setLoopThemes(state, action) {
            state.loopThemes = action.payload;
        },
        addLoopTheme(state, action) {
            state.loopThemes = [...state.loopThemes, action.payload];
        },
        updateLoopTheme(state, action) {
            state.loopThemes = state.loopThemes.map((theme) => {
                if (theme.id === action.payload.id) {
                    return action.payload;
                }
                return theme;
            });
        },
        removeLoopTheme(state, action) {
            state.loopThemes = state.loopThemes.filter((theme) => theme.id !== action.payload);
        },
        setLoopKPIs(state, action) {
            state.loopKPIs = action.payload;
        },
        addLoopKPI(state, action) {
            state.loopKPIs = [...state.loopKPIs, action.payload];
        },
        updateLoopKPI(state, action) {
            state.loopKPIs = state.loopKPIs.map((kpi) => {
                if (kpi.id === action.payload.id) {
                    return action.payload;
                }
                return kpi;
            });
        },
        removeLoopKPI(state, action) {
            state.loopKPIs = state.loopKPIs.filter((kpi) => kpi.id !== action.payload);
        },
        setLoopGoals(state, action) {
            state.loopGoals = action.payload;
        },
        addLoopGoal(state, action) {
            state.loopGoals = [...state.loopGoals, action.payload];
            state.loopKPIs = state.loopKPIs.map((kpi) => {
                if (kpi.id === action.payload.loop_kpi) {
                    return {
                        ...kpi,
                        loop_goals: [...(kpi.loop_goals || []), action.payload]
                    };
                }
                return kpi;
            });
        },
        updateLoopGoal(state, action) {
            state.loopGoals = state.loopGoals.map((goal) => {
                if (goal.id === action.payload.id) {
                    return action.payload;
                }
                return goal;
            });
            state.loopKPIs = state.loopKPIs.map((kpi) => {
                return {
                    ...kpi,
                loop_goals: (kpi.loop_goals || []).map((goal) => {
                    if (goal.id === action.payload.id) {
                        return action.payload;
                    }
                    return goal;
                })
            };
            });
        },
        removeLoopGoal(state, action) {
            state.loopGoals = state.loopGoals.filter((goal) => goal.id !== action.payload);
            state.loopKPIs = state.loopKPIs.map((kpi) => {
                return {
                    ...kpi,
                    loop_goals: (kpi.loop_goals || []).filter((goal) => goal.id !== action.payload)
                };
            });
        },
        setLoopLayers(state, action) {
            state.loopLayers = action.payload;
        },
        addLoopLayer(state, action) {
            state.loopLayers = [...state.loopLayers, action.payload];
        },
        removeLoopLayer(state, action) {
            state.loopLayers = state.loopLayers.filter((layer) => layer.id !== action.payload);
        },
        setLoopSegments(state, action) {
            state.loopSegments = action.payload;
        },
        addLoopSegment(state, action) {
            state.loopSegments = [...state.loopSegments, action.payload];
        },
        updateLoopSegment(state, action) {
            state.loopSegments = state.loopSegments.map((segment) => {
                if (segment.id === action.payload.id) {
                    return action.payload;
                }
                return segment;
            });
        },
        removeLoopSegment(state, action) {
            state.loopSegments = state.loopSegments.filter((segment) => segment.id !== action.payload);
        },
        setLoopLoading(state, action) {
            state.loading = action.payload;
        },
        setLoopError(state, action) {
            state.error = action.payload;
        },
        setLoopLength(state, action) {
            state.length = action.payload;
        },
        clearLoopData(state) {
            state.currentLoop = null;
            state.loopThemes = [];
            state.loopKPIs = [];
            state.loopGoals = [];
            state.loopLayers = [];
            state.loopSegments = [];
            state.error = null;
            state.length = null;
        }
    },
});

export const {
    setCurrentLoop,
    setLoopThemes,
    addLoopTheme,
    updateLoopTheme,
    removeLoopTheme,
    setLoopKPIs,
    addLoopKPI,
    updateLoopKPI,
    removeLoopKPI,
    setLoopGoals,
    addLoopGoal,
    updateLoopGoal,
    removeLoopGoal,
    setLoopLayers,
    addLoopLayer,
    removeLoopLayer,
    setLoopSegments,
    addLoopSegment,
    updateLoopSegment,
    removeLoopSegment,
    setLoopLoading,
    setLoopError,
    setLoopLength,
    clearLoopData,
} = loopSlice.actions;

export default loopSlice.reducer; 